export default __webpack_public_path__ + "static/media/ceq.b2103711.svg";